if (!customElements.get('sale-countdown-banner')) {
  class SaleCountdownBanner extends HTMLElement {
    connectedCallback() {
      if (this.dataset.expired === 'true') return;

      const saleEnd = this.dataset.saleEnd;
      if (!saleEnd) return;

      this._endDate = new Date(saleEnd);
      if (isNaN(this._endDate.getTime())) return;

      this._daysEl = this.querySelector('[data-days]');
      this._hoursEl = this.querySelector('[data-hours]');
      this._minutesEl = this.querySelector('[data-minutes]');
      this._secondsEl = this.querySelector('[data-seconds]');
      this._daysWrapEl = this.querySelector('[data-days-wrap]');
      this._daysSepEl = this.querySelector('[data-days-sep]');

      if (this._endDate <= Date.now()) {
        this._markExpired();
        return;
      }

      this._tick();
      this._interval = setInterval(() => this._tick(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this._interval);
    }

    _markExpired() {
      clearInterval(this._interval);
      this.dataset.expired = 'true';
    }

    _tick() {
      const diff = this._endDate - Date.now();

      if (diff <= 0) {
        this._markExpired();
        return;
      }

      const d = Math.floor(diff / 86400000);
      const h = Math.floor((diff % 86400000) / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const s = Math.floor((diff % 60000) / 1000);

      if (this._daysEl) this._daysEl.textContent = String(d).padStart(2, '0');
      if (this._hoursEl) this._hoursEl.textContent = String(h).padStart(2, '0');
      if (this._minutesEl) this._minutesEl.textContent = String(m).padStart(2, '0');
      if (this._secondsEl) this._secondsEl.textContent = String(s).padStart(2, '0');

      const showDays = d > 0;
      if (this._daysWrapEl) this._daysWrapEl.style.display = showDays ? '' : 'none';
      if (this._daysSepEl) this._daysSepEl.style.display = showDays ? '' : 'none';
    }
  }

  customElements.define('sale-countdown-banner', SaleCountdownBanner);
}
